import { render, staticRenderFns } from "./DetailTableButton.vue?vue&type=template&id=10f36220&"
import script from "./DetailTableButton.vue?vue&type=script&lang=js&"
export * from "./DetailTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports